module.exports = require("isarray");


//////////////////
// WEBPACK FOOTER
// external "isarray"
// module id = 383
// module chunks = 0